// extracted by css-extract-rspack-plugin
export default {"cls1":"WorkCard-cls1_O2o","cls2":"WorkCard-cls2_NG6 WorkCard-cls1_O2o"};